import moment from 'moment';
import 'moment/locale/pt-br';

export default moment;



// WEBPACK FOOTER //
// ./src/config/Moment.js